/**
 * @param {BreadCrumbsConfigItem} config
 * @return {string}
 */
export const makeTitleFromBreadCrumbs = (config) =>
  [config.label, ...(config.crumbs || []).map((item) => item.label).reverse(), "Skyportal"].join(" - ");
